import request from './request';

// 获取帮助内容列表
export function getHelpList() {
  return request({
    url: '/api/help/list',
    method: 'get'
  });
}

// 根据ID获取帮助内容详情
export function getHelpById(id) {
  return request({
    url: `/api/help/${id}`,
    method: 'get'
  });
}

// 创建帮助内容
export function createHelp(data) {
  // 确保数据格式符合后端要求
  const helpContent = {
    title: data.title,
    content: data.content,
    imageBase64List: data.imageBase64List || [],
    sortOrder: data.sortOrder || 0
  };
  
  return request({
    url: '/api/help',
    method: 'post',
    data: helpContent
  });
}

// 更新帮助内容
export function updateHelp(id, data) {
  // 确保数据格式符合后端要求
  const helpContent = {
    id: id,
    title: data.title,
    content: data.content,
    imageBase64List: data.imageBase64List || [],
    sortOrder: data.sortOrder || 0
  };
  
  return request({
    url: `/api/help/${id}`,
    method: 'put',
    data: helpContent
  });
}

// 删除帮助内容
export function deleteHelp(id) {
  return request({
    url: `/api/help/${id}`,
    method: 'delete'
  });
}

// 更新帮助内容排序
export function updateHelpSortOrder(id, newSortOrder) {
  return request({
    url: `/api/help/${id}/sort-order`,
    method: 'put',
    params: { newSortOrder }
  });
}